import RectObject from "./RectObject";


class Player extends RectObject {
    constructor() {
        super(...arguments);
        this.velocity = {
            x: 0,
            y: 0,
        };
        this.acceleration = 1; //additive
        this.deceleration = 0.9; //multiplicative. Speed cap will be acceleration/(1-deceleration)
        this.jumpForce = 20; //additive, may need to be adjusted depending on screen size
        this.isGrounded = true;
        this.fillStyle = "#99c9ff";
    }

    move() {
        this.verticalMovement();
        this.horizontalMovement();
    }

    verticalMovement() {
        if (!this.isGrounded) {
            this.velocity.y += this.game.gravity;
        } else if (this.game.keys.up && this.game.isGameActive()) {
            this.velocity.y -= this.jumpForce;
        }
        this.position.y += this.velocity.y;
        this.isGrounded = false;
        this.game.platforms.forEach((platform) => {
            const topsideCollisionRules = [
                this.position.x + this.width > platform.position.x,
                this.position.x < platform.position.x + platform.width,
                this.position.y < platform.position.y,
                this.position.y + this.height > platform.position.y,
            ];
            const undersideCollisionRules = [
                this.position.x + this.width > platform.position.x,
                this.position.x < platform.position.x + platform.width,
                this.position.y > platform.position.y,
                this.position.y < platform.position.y + platform.height,
            ];
            if (topsideCollisionRules.every((rule) => rule)) {
                this.position.y = platform.position.y - this.height;
                this.velocity.y = 0;
                this.isGrounded = true;
            } else if (undersideCollisionRules.every((rule) => rule)) {
                this.position.y = platform.position.y + platform.height;
                this.velocity.y = 0;
            }
        });
        if (this.position.y < this.game.margin.top) {
            this.position.y = this.game.margin.top;
            this.velocity.y = 0;
        } else if (this.position.y + this.height >= this.game.canvas.height - this.game.margin.bottom) {
            this.position.y = this.game.canvas.height - this.height - this.game.margin.bottom;
            this.velocity.y = 0;
            this.isGrounded = true;
        }
    }

    horizontalMovement() {
        if (this.game.keys.right && this.game.isGameActive()) {
            this.velocity.x += this.acceleration;
        }
        if (this.game.keys.left && this.game.isGameActive()) {
            this.velocity.x -= this.acceleration;
        }
        this.velocity.x *= this.deceleration;
        this.position.x += this.velocity.x;
        this.game.platforms.forEach((platform) => {
            const frontalCollisionRules = [
                this.position.y + this.height > platform.position.y,
                this.position.y < platform.position.y + platform.height,
                this.position.x < platform.position.x,
                this.position.x + this.width > platform.position.x
            ];
            const rearCollisionRules = [
                this.position.y + this.height > platform.position.y,
                this.position.y < platform.position.y + platform.height,
                this.position.x > platform.position.x,
                this.position.x < platform.position.x + platform.width
            ];
            if (frontalCollisionRules.every(rule => rule)) {
                this.position.x = platform.position.x - this.width;
                this.velocity.x = 0;
            } else if (rearCollisionRules.every(rule => rule)) {
                this.position.x = platform.position.x + platform.width;
                this.velocity.x = 0;
            }
        });
        const horizonalAdjustment =
            this.position.x < this.game.margin.left
                ? this.game.margin.left - this.position.x
                : this.position.x + this.width > this.game.canvas.width - this.game.margin.right
                    ? this.game.canvas.width - this.game.margin.right - this.position.x - this.width
                    : 0;
        if (horizonalAdjustment !== 0) {
            this.game.checkpoints.forEach((checkpoint) => {
                checkpoint.position.x += horizonalAdjustment;
            });
            this.game.platforms.forEach((platform) => {
                platform.position.x += horizonalAdjustment;
            });
            this.position.x += horizonalAdjustment;
        }
    }

    evaluateCheckpoints() {
        this.game.checkpoints.forEach((checkpoint, index) => {
            const collisionRules = [
                this.position.x + this.width > checkpoint.position.x,
                this.position.x < checkpoint.position.x + checkpoint.width,
                this.position.y + this.height > checkpoint.position.y,
                this.position.y < checkpoint.position.y + checkpoint.height
            ];

            if (collisionRules.every(rule => rule)) {
                //Remove checkpoint
                this.game.checkpoints.splice(index, 1);
                //
                // //Display checkpointMessage
                // checkpointScreen.style.display = "block";
                // if (isGameActive()) {
                //     checkpointMessage.innerText = "You reached a checkpoint!";
                //     setTimeout(() => (checkpointScreen.style.display = "none"), 2000);
                // } else {
                //     checkpointMessage.textContent = "You reached the final checkpoint!";
                // }
            }
        });
    }
}

export default Player